export function SocialScorerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 34V22l14-12 14 12v12" />
      <path d="M10 34h28" />
      <circle cx="24" cy="26" r="4" />
      <path d="M24 30v4" />
    </svg>
  );
}
